import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';

function isScreenReaderEnabled() {
  return new Promise(function (resolve, reject) {
    resolve(true);
  });
}

var prefersReducedMotionMedia = canUseDOM ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

function isReduceMotionEnabled() {
  return new Promise(function (resolve, reject) {
    resolve(prefersReducedMotionMedia ? prefersReducedMotionMedia.matches : true);
  });
}

var handlers = {};
var AccessibilityInfo = {
  isScreenReaderEnabled: isScreenReaderEnabled,
  isReduceMotionEnabled: isReduceMotionEnabled,
  fetch: isScreenReaderEnabled,
  addEventListener: function addEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      if (!prefersReducedMotionMedia) {
        return;
      }

      var listener = function listener(event) {
        handler(event.matches);
      };

      prefersReducedMotionMedia.addEventListener('change', listener);
      handlers[handler] = listener;
    }

    return {
      remove: function remove() {
        return AccessibilityInfo.removeEventListener(eventName, handler);
      }
    };
  },
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},
  announceForAccessibility: function announceForAccessibility(announcement) {},
  removeEventListener: function removeEventListener(eventName, handler) {
    if (eventName === 'reduceMotionChanged') {
      var listener = handlers[handler];

      if (!listener || !prefersReducedMotionMedia) {
        return;
      }

      prefersReducedMotionMedia.removeEventListener('change', listener);
    }

    return;
  }
};
export default AccessibilityInfo;